import styled from "styled-components";

export const SearchInput = styled.input`
  border: none;
  border-bottom: 1px solid ${({ theme }): string => theme.colors.yellow};
  padding: 5px 0px;
  font-size: 1rem;
  width: 100%;
  outline: none;
  color: ${({ theme }): string => theme.colors.white};
  background-color: transparent !important;

  transition: all 0.2s ease-in-out;
  &::placeholder {
    opacity: 0.45;
    color: ${({ theme }): string => theme.colors.yellow};
    font-size: 1rem;
  }

  &:focus {
    border-bottom: 2px solid ${({ theme }): string => theme.colors.yellow};
    padding: 5px 0px;
  }
`;
